import { render, staticRenderFns } from "./cardCustom2Values.vue?vue&type=template&id=3154e6ba"
import script from "./cardCustom2Values.vue?vue&type=script&lang=js"
export * from "./cardCustom2Values.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports